<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/moneyBack_list',title:'回款管理'},{title:'回款列表（外）'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox width">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
                            <el-form-item label="导入序号/ID">
                                <el-input v-model="formInline.inId" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="汇款人名称">
                                <el-input v-model="formInline.remitterName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经销商姓名">
                                <el-input v-model="formInline.customerName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经销商编码">
                                <el-input v-model="formInline.customerCode" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">

                            <el-form-item label="销售组织" prop="saleGroupCode">
                                <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true"
                                          v-model="formInline.saleGroupCode" clearable></brselect>
                            </el-form-item>

                            <el-form-item label="凭证编号">
                                <el-input v-model="formInline.receCertNumber" placeholder="请输入"></el-input>
                            </el-form-item>
							<el-form-item label="认领状态">
                                <brselectlazy category="claimed_type" :v="formInline.isClaimeds"
                                              :multiple="true"
                                              :collapseTags="true"
                                              v-model="formInline.isClaimeds"  :clearable="true"/>
							</el-form-item>
                            <el-form-item label="文本">
                                <el-input v-model="formInline.text" placeholder="请输入"></el-input>
                            </el-form-item>

						</div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="回款时间" style="width: 50%;">
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.startReceDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                placeholder="请选择"
                                                v-model="formInline.endReceDate"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>

                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
							</el-button>
<!--							<el-button class="h-btn h-formBtn h-bggreen" v-auth="'claimImport'" icon="el-icon-plus"-->
<!--							           @click="addMoneyBack">新增回款-->
<!--							</el-button>-->
						</div>
					</div>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <div>
                    <div  style="color: red;font-size: 14px;">认领中：已经认领入账到客户金额未全部关联订单，可继续认领关联未回款订单</div>
                    <div  style="color: red;font-size: 14px;">审核中：业务经理初次认领，待财务审核入账</div>
                    <div style="color: #616467;font-size: 14px;">已入账金额：{{sumShow.sum}} 已认领金额：{{sumShow.enterSum}} 手续费：{{sumShow.commission}} 认领到订单：{{sumShow.orderSum}} 余额：{{sumShow.balance}}</div>
                </div>
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData2.records"
                        stripe
                        style="width: 100%"
						max-height="450"
						:border="true">
                    <el-table-column
                            type="selection"
                            width="40"
                            label="全选">
                    </el-table-column>

                    <el-table-column
                            prop="remitterName"
                            label="汇款人名称"
                            :show-overflow-tooltip="true"
                            min-width="200">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.remitterName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="receBank"
                            label="汇款银行"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receDate"
                            label="回款时间"
                            :show-overflow-tooltip="true"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receCurrency"
                            label="币种"
                            :show-overflow-tooltip="true"
                            width="50"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="receAmount"
                            label="入账金额"
                            :show-overflow-tooltip="true"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="enterAmount"
                            label="认领金额"
                            :show-overflow-tooltip="true"
                            width="80"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="saleGroupCode"
                            label="销售组织"
                            :show-overflow-tooltip="true"
                            min-width="80">
                    </el-table-column>
                    <el-table-column
                            prop="customerCode"
                            label="经销商编码"
                            :show-overflow-tooltip="true"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            prop="customerName"
                            label="经销商名称"
                            :show-overflow-tooltip="true"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            prop="isClaimed"
                            label="认领状态"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <dictname category="claimed_type" :v="scope.row.isClaimed"/>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                            prop="receMark"-->
                    <!--                            label="回款类型"-->
                    <!--                            :show-overflow-tooltip="true"-->
                    <!--                    >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <dictname category="credit_type" :v="scope.row.receMark"/>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            prop="claimDate"
                            label="认领时间"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            prop="balanceAmount"
                            label="认领余额"
                            :show-overflow-tooltip="true"
                            width="100"

                    >
                    </el-table-column>

                    <el-table-column
                            prop="wenben"
                            label="文本"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            prop="swwWenben"
                            label="文本"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column

                            prop="inId"
                            label="导入序号"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="id"
                            label="ID"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="receCertNumber"
                            label="凭证编号"
                            min-width="100"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column

                            prop="blart"
                            label="凭证类型"
                            min-width="77"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            :show-overflow-tooltip="true"
                            width="120"

                    >
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160"
                    >
                        <template slot-scope="scope">
                           <div style="display: flex;justify-content: flex-start;align-items: center;">
                                <el-button
										style="padding: 0;"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn"
                                        v-if="showLook(scope.row)"
                                        @click="detail(scope.row),look">
                                    查看
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
										style="padding: 0;"
                                        class="h-tableLink h-btn"
                                        v-if="showClaim(scope.row)"
                                        @click="taps(scope.row),go">
                                    认领
                                </el-button>
                               <el-button
                                       v-auth="'claimChongx'"
                                       type="text"
                                       size="small"
                                       style="padding: 0;"
                                       class="h-tableLink h-btn"
                                       v-if="showChongx(scope.row)"
                                       @click="chongx(scope.row)">
                                   冲销
                               </el-button>
                                <el-button
                                        type="text"
                                        size="small"
										style="padding: 0;"
                                        class="h-tableLink h-btn"
                                        v-if="showContinue(scope.row)"
                                        @click="toContinue(scope.row)">
                                    重新认领
                                </el-button>
<!--                                <el-button-->
<!--                                        type="text"-->
<!--                                        size="small"-->
<!--										style="padding: 0;"-->
<!--                                        class="h-tableLink h-btn"-->
<!--                                        v-if="showBandOrders(scope.row)"-->
<!--                                        @click="taps(scope.row),go">-->
<!--                                    绑定订单-->
<!--                                </el-button>-->
                               <el-button
                                       v-auth="'claimImport'"
                                       type="text"
                                       size="small"
                                       style="padding: 0;"
                                       class="h-tableLink h-btn"
                                       v-if="showDel(scope.row)"
                                       @click="toDel(scope.row)">
                                   删除
                               </el-button>
                            </div>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" v-if="showLook(scope.row)" title="查看" @click="detail(scope.row),look"></span>
								<span class="l-operationlist br-operation-rl" v-if="showClaim(scope.row)" title="认领" @click="taps(scope.row),go"></span>
								<span class="l-operationlist br-operation-xg" v-if="showContinue(scope.row)" title="编辑" @click="toContinue(scope.row)"></span>
								<span class="l-operationlist br-operation-bddd" v-if="showBandOrders(scope.row)" title="绑定订单" @click="taps(scope.row),go"></span>
							</div> -->
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>新增回款</h1>
                                <p>New Cash</p>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine h-mrb-38">
                        <el-form :model="formLabelAlign2" :rules="rules2" ref="formLabelAlign2"
                                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
<!--                            <el-form-item label="银行名称" class="h-elformWrap-2" prop="receBank">-->
<!--                                <brselectlazy category="BankCategory_agent" :v="formLabelAlign2.receBank"-->
<!--                                              v-model="formLabelAlign2.receBank" :clearable="true"/>-->
<!--                            </el-form-item>-->
                            <el-form-item label="凭证编号" class="h-elformWrap-2" prop="receCertNumber">
                                <el-input v-model="formLabelAlign2.receCertNumber"></el-input>
                            </el-form-item>
                            <el-form-item label="凭证类型" class="h-elformWrap-2" prop="blart">
                                <brselectlazy  category="hk_pingzhengleixing"  :v="formLabelAlign2.blart"  v-model="formLabelAlign2.blart"
                                              :clearable="true"
                                              :showcode="true"
                                />
                            </el-form-item>
                            <el-form-item label="客户姓名" class="h-elformWrap-2" prop="remitterName">
                                <el-select filterable placeholder="请选择" v-model="formLabelAlign2.customerCode"
                                           @change="queryUserCode"
                                           >
                                    <el-option v-for="(item) in user"
                                               :key="item.usercode"
                                               :label="'['+item.usercode+']'+item.customerName1"
                                               :value="item.usercode">
                                        <span style="float: left">{{ item.customerName1 }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.usercode}}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="销售组织" prop="saleGroupCode" class="h-elformWrap-2 ">
                                <brselect category="xiaoshou_zuzhi" :v="formLabelAlign2.saleGroupCode" :showcode="true"
                                          v-model="formLabelAlign2.saleGroupCode" clearable ></brselect>
                            </el-form-item>

                            <!--                    <el-form-item label="类型" class="h-elformWrap-2" prop="receMark">-->
                            <!--                        <el-select v-model="formLabelAlign2.receMark" placeholder="请选择">-->
                            <!--                            <el-option label="预付款" value="1"></el-option> -->
                            <!--                            <el-option label="赊销回款" value="2"></el-option>-->
                            <!--                        </el-select>-->
                            <!--                    </el-form-item>-->
                            <el-form-item label="币种" class="h-elformWrap-2" prop="receCurrency">
                                <mdmselect category="YLCurrency" :v="formLabelAlign2.receCurrency"
                                           v-model="formLabelAlign2.receCurrency" :clearable="true"/>
                            </el-form-item>
                            <el-form-item label="银行入账金额" class="h-elformWrap-2" prop="receAmount">
                                <el-input size="mini" v-model="formLabelAlign2.receAmount" controls-position="right"/>
                                <span style="position:absolute;left:90%">元</span>
                            </el-form-item>

                            <el-form-item label="凭证日期" class="h-elformWrap-2" prop="receDate">
                                <el-date-picker
                                        v-model="formLabelAlign2.receDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="会计年度" class="h-elformWrap-2" prop="receCertNumber">
                                <el-input v-model="formLabelAlign2.gjahr" maxlength="4"></el-input>
                            </el-form-item>
                            <el-form-item label="汇款人常驻国家" class="h-elformWrap-2" prop="countryCode">
                                <!--                        <el-select v-model="formLabelAlign2.countryCode" placeholder="请选择">-->
                                <!--                            <el-option label="中国" value="中国"></el-option>-->
                                <!--                            <el-option label="美国" value="美国"></el-option>-->
                                <!--                        </el-select>-->
                                <brselectlazy filterable category="YLCountry_agent" :v="formLabelAlign2.countryCode"
                                              v-model="formLabelAlign2.countryCode"
                                              :clearable="true"
                                              :showcode="true"
                                />
                            </el-form-item>
                            <el-form-item label="交易附言" class="h-elformWrap-2 shouxufei" prop="tradeWay">

                                <brselectlazy filterable category="jiaoyifuyan" :v="formLabelAlign2.tradeWay"
                                              v-model="formLabelAlign2.tradeWay"
                                              :clearable="true"
                                />
                            </el-form-item>


                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert('formLabelAlign2')">提 交
                        </el-button>
                    </div>
                </el-dialog>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                        <el-button  class="h-btn h-formBtn h-bgblueQ" v-auth="'claimImport'" icon="h-el-icon h-el-icon-export"
                                   @click="uploaddownexcelflagbtn">批量导入
                        </el-button>
<!--                        <bruploadchi-->
<!--						style="margin-top: 0.2rem;"-->
<!--                                tips="凭证文件命名为对应回款编号，如批量绑定，回款编号以英文逗号分隔"-->
<!--                                :refid="refid"-->
<!--                                :reftype="reftype"-->
<!--                                uploadflag-->
<!--                                delflag-->
<!--                        >-->
<!--                        </bruploadchi>-->
                        <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                         clsname="createForeignImportExcel"
                                         :startrow="2" @callback="uploadExcelFilecallback"/>

                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="choose"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from "../../../utils/updownfile";
    import _ from "loadsh";


    export default {
        components: {
            uploaddownexcel,
        },
        name: 'leftMenu',
        data() {
            var validatereceAmount = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入金额'));
                } else {
                    const age = /^\d+$|^\d*\.\d+$/g;
                    if (!age.test(value)) {
                        callback(new Error('金额只能为数字！'))
                    } else {
                        callback()
                    }
                }
            };
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                refid: '111',
                reftype:'回款认领-上传凭证',
                uploaddownexcelflag: false,
                value2: '',
                user: {} ,
                rules2: {
                    receCertNumber: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    blart: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    customerCode: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    saleGroupCode: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    receCurrency: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    receAmount:
                        [
                            {required: true, validator: validatereceAmount, trigger: 'blur'},
                        ],
                    receDate: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    countryCode: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    tradeWay: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    gjahr: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],


                },
                page: {},
                q: {
                    // codeLikenameLike: null,
                    // categoryLikecatenameLike: null,
                    // delflag: null,
                    isClaimed : '0',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0
                },
                //表单
                formInline: {
                    remitterName: '',
                    isClaimeds: '0',
                    startReceDate: '',
                    endReceDate: '',
                    receMark: '',
                    pageSize: 10,
                    pageNo: 1
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                sumShow:{
                    balance : '正在获取中',
                    enterSum : '正在获取中',
                    sum : '正在获取中',
                    orderSum : '正在获取中',
                    commission : '正在获取中'
                },
                //弹框
                dialogFormVisible: false,
                dialogFormVisible2: false,
                formLabelAlign2: {
                    remitterName: null,
                    receAmount: null,
                    receCurrency: null,
                    receCertNumber: null,
                    receDate: null,
                    remitterCode: null,
                    countryCode: null,
                    tradeWay: null,
                    checkboxGroup1: [],
                    blart :null,
                    saleGroupCode:null,
                    gjahr : null,
                    customerCode : null,
                },
                cities: ['非洲', '亚太', 'UN'],
                flag: 0,
                status: true,
                bscUserInfoAgentBasic: {
                    region: null,
                }
            }
        },

        created() {
            this.queryUser();
            this.search();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            uploadExcelFilecallback(rd) {
                console.log(rd)
                if (rd == null) {
                } else {
                    this.$msg.alert(rd.msg);
                    this.search();
                }

            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            //批量导出
            exportExcel() {
                // var idlist = [];
                // this.multipleSelection.forEach(element => {
                //     idlist.push(element.id);
                // });
                var form = _.clone(this.formInline);
                // form.ddstatus=_.join(this.ddstatusList,",");
                updownfile.down("/api/swyl/v1/foreign/userReceForeign/downloadExcel", form, "post");
            },
            inputExeal() {
                // ss.moneyBackforeignService.
            },
            timeSelect() {
                this.formInline.startReceDate = this.value2[0];
                this.formInline.endReceDate = this.value2[1];
            },
            download() {
                //ids
                var cc = [];

                for (var d in this.tableData2.records.id) {

                    cc.push(this.tableData2.records[d].id);

                }

                //查询参数
                var c = {

                    ids: cc,

                };

                ss.moneyBackforeignService.download(c);
            },

            //是否显示查看按钮
            showLook(v) {
                if (v.isClaimed === 3) {
                    return false;
                } else {
                    return true;
                }
            },
            //是否显示认领按钮
            showClaim(v) {
                if (v.isClaimed === 2 || v.isClaimed === 3 || v.isClaimed === 4 || v.isClaimed === 5 || v.isClaimed === 6 || v.isClaimed === 7 || v.isClaimed === 8) {
                    return false;
                } else {
                    return true;
                }
            },
            showChongx(v) {
                if (v.receCertNumber === '' || v.receCertNumber === undefined  || v.isClaimed === 7) {
                    return false;
                } else {
                    return true;
                }
            },
            showDel(v) {
                if (v.isClaimed === 0) {
                    return true;
                } else {
                    return false;
                }
            },
            //是否显示继续编辑按钮
            showContinue(v) {
                if (v.isClaimed === 5) {
                    return true;
                } else {
                    return false;
                }
            },
            //是否显示绑定订单按钮
            showBandOrders(v) {
                if (v.isClaimed === 6) {
                    return true;
                } else {
                    return false;
                }
            },
            choose() {
                if (this.flag === 1) {
                    this.search();
                } else {
                    this.query();
                }
            },
            searchReset() {
                this.q.pageNo = 1;
                this.search();
            },
            //根据条件检索
            search() {
                this.formInline.pageNo = this.q.pageNo;
                this.formInline.pageSize = this.q.pageSize;

                ss.moneyBackforeignService.conditionalSearch(this.formInline).then(response => {
                    console.log(response)
                    this.q.total = response.total;
                    // console.log(rd);
                    this.tableData2 = response;
                    this.flag = 1;

                })
                this.sumShow.balance = '正在获取中';
                this.sumShow.enterSum = '正在获取中';
                this.sumShow.sum = '正在获取中';
                this.sumShow.orderSum = '正在获取中';
                this.sumShow.commission = '正在获取中';

                 ss.moneyBackforeignService.conditionalSearchSum(this.formInline).then(response => {
                     this.sumShow.balance = parseFloat(response.balance).toFixed(2);
                     this.sumShow.enterSum = parseFloat(response.enterSum).toFixed(2);
                     this.sumShow.sum = parseFloat(response.sum).toFixed(2);
                     this.sumShow.orderSum = parseFloat(response.enterSum - response.balance).toFixed(2);
                     this.sumShow.commission = parseFloat(response.commission).toFixed(2);

                })
            },
            //重置检索项
            resetData() {
                this.value2 = '';
                this.formInline.remitterName = '';
                this.formInline.isClaimeds = '0';
                this.formInline.startReceDate = '';
                this.formInline.endReceDate = '';
                this.formInline.receMark = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.flag = 0;
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;
                this.search();
            },
            chongx(v){
                this.$confirm("确定要冲销【"+v.receCertNumber + '】这笔凭证吗？', '提示')
                    .then(_ => {
                        ss.moneyBackforeignService.chongx(v).then(response => {
                            this.query();
                            this.$message({
                                type: "success",
                                message: response.msg
                            });
                        })

                    })
                    .catch(_ => {
                    })
            },
            toDel(v){
                this.$confirm("确定要删除吗？", '提示')
                    .then(_ => {
                        ss.moneyBackforeignService.toDel(v).then(response => {
                            this.query();
                            this.$message({
                                type: "success",
                                message: response.msg
                            });
                        })
                    })
                    .catch(_ => {
                    })
            },
            go() {
			    let v = {backurl:"moneyBack_list"}
                this.$router.push({path: '/moneyBack_claim', query: v})
            },
            taps(v) {
                if (v.isClaimed === 2) {
                    this.$message({
                        type: "warning",
                        message: '该回款已被认领，无法重复认领！'
                    });
                } else {
                    v.backurl = "moneyBack_list";
                    this.$router.push({path: "/moneyBack_claim", query: v});
                }
            },
            //继续编辑
            toContinue(v) {
//                 v.backurl = "moneyBack_list";
                this.$router.push({
                    path: "/moneyBack_claim",
                    query: { ywid: v.id, instid: v.instid, backurl:"moneyBack_list"}
                })
                // this.$router.push({path: '/moneyBack_claim', query: v})

            },
            look() {
                let v = {backurl:"moneyBack_list"}
                this.$router.push({path: '/moneyBack_detail', query: v})
            },
            detail(v) {
                v.backurl = "moneyBack_list";
                this.$router.push({path: "/moneyBack_detail", query: v});
                console.log(v, "aaaaaaaaaaaa")
            },
            // 查询外回款分页列表
            query() {
                this.search()
            },
            //每次点击新增回款时重置表单和校验结果
            addMoneyBack() {
                this.dialogFormVisible = true;
                console.log(this.status, 'aaaaaaaaaa')
                if (this.status) {
                    this.$nextTick(() => {
                        this.$refs["formLabelAlign2"].resetFields();
                    });
                }

            },
            queryUserCode(v) {
                for (var i = 0; i < this.user.length; i++) {
                    if (this.user[i].usercode == v) {
                        //this.q.soldToCode = this.user[i].usercode;
                        this.formLabelAlign2.remitterName = this.user[i].customerName1;

                    }
                }
            },
            queryUser() {
                console.log(this._user, "当前登录人")
                this.bscUserInfoAgentBasic.region = this._user.area;
                ss.moneyBackClaimService.query(this.bscUserInfoAgentBasic).then(rd => {
                    console.log(rd);
                    this.user = rd;
                })
            },
            //新增回款
            insert(form) {
                console.log(this.formLabelAlign2);
                this.$refs[form].validate((valid) => {
                    if (valid) {

                        ss.moneyBackforeignService.insert(this.formLabelAlign2).then(response => {
                            console.log(response);
                            if (response.f) {
                                this.dialogFormVisible = false;
                                this.query();
                                this.$message({
                                    type: "success",
                                    message: response.msg
                                });
                                this.formLabelAlign2= {
                                    remitterName: null,
                                        receAmount: null,
                                        receCurrency: null,
                                        receCertNumber: null,
                                        receDate: null,
                                        remitterCode: null,
                                        countryCode: null,
                                        tradeWay: null,
                                        checkboxGroup1: [],
                                        blart :null,
                                        saleGroupCode:null,
                                        gjahr : null,
                                        customerCode : null,
                                }
                            }
                        })
                    } else {
                        return false;
                    }
                });
                this.status = true;
            },
            //暂存草稿
            rough() {
                // this.status = false;
                this.formLabelAlign2.areaCode = this.formLabelAlign2.checkboxGroup1.toString();
                ss.moneyBackforeignService.insertRough(this.formLabelAlign2).then(response => {
                    if (response.f) {
                        this.dialogFormVisible = false;
                        this.query();
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                    }
                })
            },
            //取消新增
            cancel() {
                this.dialogFormVisible = false;
                this.status = true;
                this.$message({
                    type: "warning",
                    message: '已取消新增'
                });
            },

            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        }
    }
</script>

<style>
	.dialogForms .h-elformWrap-2 {
	    width: 50%!important;
	}
    .dialogForms .h-elformWrap-2 .el-form-item__label {
        width: 50%;
    }

    .dialogForms .h-elformWrap-2 .el-form-item__content {
        width: 50%;
    }

    .width .el-date-editor .el-range-separator {
        width: 9%;
		line-height: 0.35rem;
    }

    .width .el-date-editor .el-range-input {
        width: 55%;
    }

    .width .h-formBorder .el-form-item__content {
        vertical-align: top;
    }

    /* .width .el-form--inline .el-form-item{
        margin-right: 0;
    } */
    /* .width .h-formBorder .el-form-item__content{
        width:20%;
    } */
</style>
